import type { PendingUpload } from "~/shared/store/types";
import { AttachmentPickerDialog } from "../AttachmentPickerDialog";
import type { PerKindCounts, PerKindLimits } from "../types";

import { usePickUploadedAttachment } from "./usePickUploadedAttachment";

export interface PickUploadedDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    chatId: string | null;
    /** Per-kind лимиты режима. */
    limits: PerKindLimits;
    /** Уже в pendingByChat для каждого kind. */
    currentCounts: PerKindCounts;
    onConfirm: (items: PendingUpload[]) => void;
}

export function PickUploadedDialog({
    open,
    onOpenChange,
    chatId,
    limits,
    currentCounts,
    onConfirm,
}: PickUploadedDialogProps) {
    const picker = usePickUploadedAttachment({
        chatId,
        limits,
        currentCounts,
        enabled: open,
    });

    const handleConfirm = () => {
        const items = picker.commit();
        if (items.length === 0) return;
        onConfirm(items);
    };

    return (
        <AttachmentPickerDialog
            open={open}
            onOpenChange={onOpenChange}
            picker={picker}
            onConfirm={handleConfirm}
            i18nPrefix="prompt.pickUploaded"
        />
    );
}
